import React, { useMemo } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import { useAccountUIContext } from "../AccountUIContext";

export function AccountProfile() {
  const accountUIContext = useAccountUIContext();
  const accountUIProps = useMemo(() => {
    return {
      data: accountUIContext.data,
      goToAccountResetPassword: accountUIContext.goToAccountResetPassword,
    };
  }, [accountUIContext]);
  const { data, goToAccountResetPassword } = accountUIProps;
  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Avatar
            src={data?.avatar}
            sx={{
              height: 64,
              mb: 2,
              width: 64,
            }}
          />
          <Typography color="textPrimary" gutterBottom variant="h5">
            {data?.nama_lengkap}
          </Typography>
        </Box>
      </CardContent>
      <Divider />
      {/* <CardActions sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={goToAccountResetPassword}
        >
          Reset Password
        </Button>
      </CardActions> */}
    </Card>
  );
}
